module.exports = __webpack_public_path__ + "static/media/clock-radio-dieter-rams.b162a124.jpg";